import request from "./request"
// //登陆获取token
export const getHome = (params) => request.get("index/getCarousel", params)
    // //获取登陆权限信息
    // export const getloginList = () => request.post("/auth/getUserByToken")
    // //获取商品列表
    // export const getgoodslist = (params) => request.get("/goods", {params})
    // /index/userRegister
export const userRegister = () => request.post("/index/userRegister")
    //index/userPasswordAuth
export const userPasswordAuth = () => request.post("/index/userPasswordAuth")
    // /index/indexData
export const indexData = (params) => request.get("/index/indexData", { params })
    // /index/getExamVideo
export const getExamVideo = (params) => request.get("/index/getExamVideo", { params })
    ///index/getProfession
export const getProfession = (params) => request.get("/index/getProfession", { params })
    // /index/mockList?grade_id=4
export const mockList = (params) => request.get("/index/mockList", { params })
    // /index/beginExam
export const beginExam = (params) => request.post("/index/beginExam", params)

// /api/index/config
export const index = (params) => request.get("/api/index/index", { params })
// api/index/config
export const postConfig = (params) => request.post("/api/index/config", params)
// /api/index/getNav
export const getNav = (params) => request.get("/api/index/getNav", { params })
// api/activity/cate
export const cate = (params) => request.get("/api/activity/cate", { params })
// api/activity/lists?cid=7
export const lists = (params) => request.get("/api/activity/lists", { params })
// api/activity/detail?id=8
export const associationActivitiesDetail = (params) => request.get("/api/activity/detail", { params })// api/activity/detail?id=8
export const getAboutDetail = (params) => request.get("/api/about/getAboutDetail", { params })
// api/news/cate
export const newsCate = (params) => request.get("/api/news/cate", { params })
// api/news/lists?cid=7
export const newsLists = (params) => request.get("/api/news/lists", { params })
// api/news/detail?id=8
export const newsDetail = (params) => request.get("/api/news/detail", { params })
// api/about/getCate
export const getCate = (params) => request.get("/api/about/getCate", { params })
// api/vip/lists
export const getVipLists = (params) => request.get("/api/vip/lists", { params })
// api/about/getCateContent?id=4
export const getCateContent = (params) => request.get("/api/about/getCateContent", { params })
// api/about/join
export const join = (params) => request.get("/api/about/join", { params })
// api/about/searchProfessor
export const searchProfessor = (params) => request.get("/api/about/searchProfessor", { params })
// api/about/getExpert
export const getExpert = (params) => request.get("/api/about/getExpert", { params })
// api/about/getExpertDetail?id=7
export const getExpertDetail = (params) => request.get("/api/about/getExpertDetail", { params })
// api/index/link
export const link = (params) => request.get("/api/index/link", { params })
// api/service/cate
export const serviceCate = (params) => request.get("/api/service/cate", { params })
// api/service/sonCate?pid=2
export const sonCate = (params) => request.get("/api/service/sonCate", { params })
// api/vip/cate
export const vipCate = (params) => request.get("/api/vip/cate", { params })
// api/vip/lists?cid=6
export const vipLists = (params) => request.get("/api/vip/lists", { params })
// api/vip/detail?id=8
export const vipDetail = (params) => request.get("/api/vip/detail", { params })
// api/service/detail?cid=15
export const serviceDetail = (params) => request.get("/api/service/detail", { params })
// api/research/cate
export const researchCate = (params) => request.post("/api/research/cate", params)
// api/research/lists?cid=6
export const researchLists = (params) => request.get("/api/research/lists", { params })
// api/research/detail?id=7
export const researchDetail = (params) => request.get("/api/research/detail", { params })
// api/news/dangjianCate
export const dangjianCate = (params) => request.get("/api/news/dangjianCate", { params })
// api/vip/search?name=美的
export const vipSearch = (params) => request.get("/api/vip/search", { params })
// /api/index/search?keyword=信息
export const indexSearch = (params) => request.get("/api/index/search", { params })





// WEBPACK FOOTER //
// ./src/request/api.js